import { IRegionCommodityValues } from '../../MenuFileSelectors/MenuSelectorItem';

let currentRegionCommodityMenuSelection: IRegionCommodityValues | null = null;

const useRegionCommodityMenuSelection = (): [IRegionCommodityValues | null, (selection: IRegionCommodityValues | null) => void] => {
    const regionCommodityMenuSelection = (): IRegionCommodityValues | null => currentRegionCommodityMenuSelection;

    const setRegionCommodityMenuSelection = (selection: IRegionCommodityValues | null): void => {
        currentRegionCommodityMenuSelection = selection;
    };

    return [regionCommodityMenuSelection(), setRegionCommodityMenuSelection];
};

export default useRegionCommodityMenuSelection;
